import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { I18n, Translate } from "react-redux-i18n";
import {
	AssetsManager,
	Button,
	OverlayHandler,
	TextField,
	TooltipCoachmark,
} from "cakemail-ui-components/lib/react";
import { connect } from "react-redux";
import ViewListOverlay from "assets/js/components/listSearch/ViewListOverlay";
import TagManagerOverlay from "assets/js/components/tagManager/TagManagerOverlay";

export const InlineEditableText = (props) => {
	const classRef = useRef(`tagField-${Math.floor(Math.random() * 100000000)}`);
	const [textValue, setTextValue] = useState(props.initialText);
	const [showCoachmark, setShowCoachmark] = useState(false);

	//mount
	useEffect(() => {
		setTextValue(props.initialText);
	}, [props.initialText]);

	useEffect(() => {
		if (showCoachmark) {
			document.addEventListener("click", handleHideCoachmark);
		} else {
			document.removeEventListener("click", handleHideCoachmark);
		}
		return () => {
			document.removeEventListener("click", handleHideCoachmark);
		};
	}, [showCoachmark]);

	function handleOnCHange(e) {
		setTextValue(e.currentTarget.value);
	}

	function handleCancel(e) {
		handleHideCoachmark();
	}

	function handleSave(e, button) {
		props.saveHandler(e, button, props.initialText, textValue, () => {
			handleHideCoachmark();
		});
	}

	function handleShowCoachmark() {
		setShowCoachmark(true);
	}

	function handleHideCoachmark(e) {
		let target = e?.target?.closest(`.inlineEditableText.${classRef.current}`);
		if (target == null) {
			props.cancelHandler(e);
			setTextValue(props.initialText);
			setShowCoachmark(false);
		} else {
			return;
		}
	}

	//Could use this instead of TextField if performance issue
	//<p contentEditable>{tag.name}</p>
	return (
		<div
			className={`inlineEditableText ${classRef.current}`}
			onFocus={handleShowCoachmark}
		>
			<TextField value={textValue} onChange={handleOnCHange} />
			{showCoachmark && (
				<TooltipCoachmark
					isControlled
					color="white"
					state="show"
					position="right"
					arrowPosition="arrow-left"
					content={
						<>
							<Button
								size="xsmall"
								text={<Translate value="app-general-cancel" />}
								shapeStyle="fill"
								colorTheme="grey"
								onClick={handleCancel}
							/>
							<Button
								size="xsmall"
								text={<Translate value="app-general-B-save" />}
								shapeStyle="fill"
								colorTheme="teal"
								onClick={handleSave}
								animated
								animateOnClick
							/>
						</>
					}
				/>
			)}
		</div>
	);
};
InlineEditableText.propTypes = {
	initialText: PropTypes.string,
	saveHandler: PropTypes.func,
	cancelHandler: PropTypes.func,
};

InlineEditableText.defaultProps = {
	cancelHandler: () => {},
};

export default connect((state) => {
	return {};
}, null)(InlineEditableText);
